import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { getVisitSessionId } from "@/lib/siteVisitSession";
import { useCookieConsent } from "@/context/CookieConsentContext";

const INTERVAL_MS = 45_000;

/** Nyilvános oldal — aktív látogatók számlálása az admin áttekintőhöz. */
export function SiteVisitHeartbeat() {
  const { pathname } = useLocation();
  const { allows, consent } = useCookieConsent();
  const statisticsOk = allows("statistics");

  useEffect(() => {
    if (pathname.startsWith("/admin")) return undefined;
    if (!statisticsOk) return undefined;

    const ping = () => {
      api.post("/site/heartbeat", {
        session_id: getVisitSessionId(),
        path: pathname,
      }).catch(() => {});
    };

    ping();
    const t = setInterval(ping, INTERVAL_MS);
    return () => clearInterval(t);
  }, [pathname, statisticsOk, consent.decidedAt]);

  return null;
}
